import useAllFavoritesList from './useAllFavoritesList';
import useUniqueList from './useUniqueList';

// Fetch a list using the provided listId.
// If listId is 'all-favorites' return useAllFavoritesList, otherwise return useUniqueList.
const useList = (listId = 'all-favorites') => {
  const isAllFavorites = !!(listId && listId === 'all-favorites');
  return isAllFavorites ? useAllFavoritesList() : useUniqueList(listId);
};

export default useList;
